import React from 'react';
import PropTypes from 'prop-types';
import { ArrowRight } from '../../assets/icons';
import './WarningBar.scss';

const WarningBar = (props) => {
  const hasAction = typeof props.action === 'function';
  return (
    <div
      className='warning-bar'
      onClick={hasAction ? props.action : undefined}
      onKeyDown={
        hasAction
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                props.action(e);
              }
            }
          : undefined
      }
      role={hasAction ? 'button' : undefined}
      tabIndex={hasAction ? 0 : undefined}
      id="warning-bar-wrap"
      style={hasAction ? undefined : { cursor: 'default' }}
    >
      <span className='warning-bar__error'>{props.message || 'Finish setting up your account to begin investing with Realbricks'}</span>{' '}
      {!!props.detailMsg && <span className='warning-bar__detail'>{props.detailMsg}</span>}{' '}
      {hasAction && <ArrowRight color='#dd0d33' size={20} verticalAlign='-4px' />}
    </div>
  );
};

WarningBar.propTypes = {
  action: PropTypes.func,
  detailMsg: PropTypes.string,
  message: PropTypes.node,
};

export default WarningBar;
